import React from "react";

const Introduction: () => JSX.Element = () => {
  return (
    <div className="mb-12 mt-28 w-full md:px-[10%]">
      <div className="flex w-full flex-col items-center">
        <div className="text-sm font-bold text-[#3D3C3C] md:text-[30px]">
          چرا دادبانان؟
        </div>
        <p className="my-7 text-xs text-[#999696] md:text-xl">
          هدف ما در دادبانان : پیوند آموزش به اشتغال{" "}
        </p>
        <div className="grid aspect-[3/2] w-full grid-cols-1 gap-0 md:grid-cols-2 md:grid-rows-3 md:gap-3 lg:grid-cols-3 lg:grid-rows-2 lg:gap-x-5 lg:gap-y-[50px]">
          <div className="relative h-full w-full transition-all duration-300 ease-in hover:scale-105">
            <img
              loading="lazy"
              src="images/introduction/one.jpg"
              className="h-full w-full object-cover shadow md:rounded-lg"
              alt="images"
            />
            <div className="absolute top-0 flex h-full w-full flex-col items-center justify-between text-white">
              <div className="h-1/3" />
              <h2 className="mt-5 h-1/3 w-full text-center font-bold md:text-base xl:text-xl">
                ناشر کتاب آنچه مشاور حقوقی باید بداند
              </h2>
              <div className="h-1/3 text-center">
                کاربردی‌ترین کتاب حقوقی کشور جهت ارائه خدمت مشاور حقوقی به
                شرکت‌های تجاری
              </div>
            </div>
          </div>
          <div className="relative h-full w-full transition-all duration-300 ease-in hover:scale-105">
            <img
              loading="lazy"
              src="images/introduction/five.png"
              className="h-full w-full object-cover shadow md:rounded-lg"
              alt="images"
            />
            <div className="absolute top-0 flex h-full w-full flex-col items-center justify-between text-white">
              <div className="h-1/3" />
              <h2 className="mt-5 h-1/3 w-full text-center font-bold md:text-base xl:text-xl">
                اولین برگزارکننده دوره پرورش مشاور حقوقی
              </h2>
              <div className="h-1/3 text-center">
                گامی برای ارتقای مهارت و توانمندسازی مشاوران حقوقی
              </div>
            </div>
          </div>
          <div className="relative h-full w-full transition-all duration-300 ease-in hover:scale-105">
            <img
              loading="lazy"
              src="images/introduction/two.jpg"
              className="h-full w-full object-cover shadow md:rounded-lg"
              alt="images"
            />
            <div className="absolute top-0 flex h-full w-full flex-col items-center justify-between p-9 text-center text-white">
              <div className="absolute top-0 flex h-full w-full flex-col items-center justify-between text-white">
                <div className="h-1/3" />

                <div className="mt-5 h-1/3">
                  <h2 className="mb-3 w-full text-center font-bold md:text-base xl:text-xl">
                    اشتغال‌زایی
                  </h2>
                  <h3 className="text-lg">معرفی افراد مستعد به بازار کار </h3>
                </div>
                <div className="flex h-1/3 items-center">
                  <p>
                    افراد علاقمند و رتبه‌های برتر دادبانان به شرکت‌های متقاضی
                    مشاور حقوقی معرفی و توصیه می‌شوند
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="relative h-full w-full transition-all duration-300 ease-in hover:scale-105">
            <img
              loading="lazy"
              src="images/introduction/four.png"
              className="h-full w-full object-cover shadow md:rounded-lg"
              alt="images"
            />
            <div className="absolute top-0 flex h-full w-full flex-col items-center  justify-between p-9 text-center text-white">
              <div className="h-1/3" />
              <div className="mt-5 h-1/3">
                <h2 className="w-full text-center font-bold md:text-base xl:text-xl">
                  همکاری با بهترین اساتید کشور
                </h2>
              </div>
              <p className="flex h-1/3 items-center">
                دادبانان در هر حوزه تخصصی با برترین اساتید همکاری میکند
              </p>
            </div>
          </div>
          <div className="relative h-full w-full transition-all duration-300 ease-in hover:scale-105">
            <img
              loading="lazy"
              src="images/introduction/three.jpg"
              className="h-full w-full object-cover shadow md:rounded-lg"
              alt="images"
            />
            <div className="absolute top-0 flex h-full w-full flex-col items-center justify-between p-9 text-center text-white">
              <div className="h-1/3" />
              <div className="mt-5 h-1/3">
                <h2 className="mb-3 w-full text-center font-bold md:text-base xl:text-xl">
                  برگزاری بیش از 500 دوره حقوقی
                </h2>
                <h3 className="text-lg">حضوری و آنلاین</h3>
              </div>
              <p className="flex h-1/3 items-center">
                دادبانان مفتخر به برگزاری بیش از 500 دوره کاربردی به صورت حضوری
                و آنلاین است
              </p>
            </div>
          </div>

          <div className="relative h-full w-full transition-all duration-300 ease-in hover:scale-105">
            <img
              loading="lazy"
              src="images/introduction/six.png"
              className="h-full w-full object-cover shadow md:rounded-lg"
              alt="images"
            />
            <div className="absolute top-0 flex h-full w-full flex-col items-center justify-between p-9 text-center text-white">
              <div className="h-1/3" />
              <h2 className="mt-5 h-1/3 w-full text-center font-bold md:text-base xl:text-xl">
                بیش از 10 هزار مدرک معتبر
              </h2>
              <p className="flex h-1/3 items-center">
                تا به امروز بیش از 10 هزار مدرک دانشگاه تهران به دانش‌پذیران
                اعطا گردیده است
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Introduction;
